// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1taTv","alert":"SettungsInbox_alert__1T0Ot"};